import ResizeObserver from "resize-observer-polyfill";
document.addEventListener("DOMContentLoaded", () => {
  try {
    const platformWrapper = document.querySelector(
      ".trading-platforms-wrapper"
    );
    const mainNavigation = document.querySelector(".main-navigation");
    const table = document.getElementById("trading-platforms");
    const header = document.getElementById("trading-platforms-header");
    const body = document.getElementById("trading-platforms-body");
    const more = document.getElementById("platforms-table-more");
    const less = document.getElementById("platforms-table-less");

    if (
      !table ||
      !header ||
      !body ||
      !mainNavigation ||
      !more ||
      !less ||
      !platformWrapper
    ) {
      return;
    }

    more.addEventListener("click", () => {
      platformWrapper.classList.add("trading-platforms--more");
    });
    less.addEventListener("click", () => {
      platformWrapper.classList.remove("trading-platforms--more");
    });

    document.addEventListener(
      "scroll",
      () => {
        window.requestAnimationFrame(() => {
          const { top } = body.getBoundingClientRect();
          const { height: menuHeight } = mainNavigation.getBoundingClientRect();
          const { height: headerHeight } = header.getBoundingClientRect();
          const scrollHeight = menuHeight + headerHeight - 16;

          if (top < scrollHeight && window.innerWidth < 1024) {
            header.style.setProperty("top", `${scrollHeight - top}px`);
          } else {
            header.style.removeProperty("top");
          }
        });
      },
      { passive: true }
    );

    const observerTableHeader = new ResizeObserver(entries => {
      for (let entry of entries) {
        const { height } = entry.contentRect;
        table.style.setProperty("--table-header-height", `${height + 32}px`);
      }
    });
    observerTableHeader.observe(header);

    const observerMainMenu = new ResizeObserver(entries => {
      for (let entry of entries) {
        const { height } = entry.contentRect;
        document.body.style.setProperty("--header-height", `${height}px`);
      }
    });

    observerMainMenu.observe(mainNavigation);
  } catch (e) {}
});
